define('responsive-gameday/views/Monitor/ViewModels/ScoringPlaysViewModel',['require','exports','module','./ViewModelBase','GameDayCore','../Events/ViewModelUpdateEvents','gameday-resource-path/gameday-resource-path','message-service/message-service','extant/extant'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        GDC = require("GameDayCore"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        MessageService = require( "message-service/message-service" ),
        exists = require("extant/extant"),
        Superclass;

    function ScoringPlaysViewModel() {
        Superclass.constructor.call(this);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_SCORES_DATA, this.handleUpdateRequest);
    }

    ViewModelBase.spawn(ScoringPlaysViewModel).define({
        moldData: function(flavor) {
            var dataPack = {};

            dataPack.game = this.gameData.game || {};
            dataPack.linescore = this.gameData.linescore || {};
            dataPack.players = this.gameData.players || {};
            dataPack.scoring = this.gameData.scores && this.gameData.scores.innings || [];
            dataPack.isScoringPlay = true;
            dataPack.teams = {
                away : this.gameData.game.away,
                home : this.gameData.game.home
            };
            dataPack.team_code = function (that) {
                    return 't' + dataPack.teams[this.home_or_away].id;
            }

            dataPack.mugshot = function(){
                return resourcePath.get('mugshot',{ pid : this.batter});
            };

            dataPack.pitcherName = function(){
                var pitcher = dataPack.players.findPlayer(this.pitcher);
                return pitcher && pitcher.first + " " + pitcher.last;
            }

            this.dataPack=dataPack;
            
            this.dispatchUpdates(UpdateEvents.UPDATE_SCORES, dataPack);
        },
        handleUpdateRequest : function(){
           var that = this;
           this.gameData = GDC.getGameData();
            if (exists(this.gameData, "scores")) {
                that.moldData();
            } else {
               MessageService.one.call(that, GDC.requestGameData('players,scores'), function(payload, evt) {
                   that.gameData = GDC.getGameData();
                   that.moldData();
               });
            }

        }
    });

    Superclass = ScoringPlaysViewModel.superclass;

    return ScoringPlaysViewModel;
});
